import api from './api'

/**
 * Catalogue formations globales — SUPER_ADMIN.
 * Contrat API existant : GET/POST /api/trainings, PUT/archive/restore.
 * Ne pas inventer d'endpoints admin dédiés.
 */
export default {
  getAll(params = {}) {
    return api.get('/trainings', {
      params: {
        scope: 'global',
        ...params,
      },
    })
  },

  getOne(id) {
    return api.get(`/trainings/${id}`)
  },

  create(payload) {
    return api.post('/trainings', {
      scope: 'global',
      ...payload,
    })
  },

  update(id, payload) {
    return api.put(`/trainings/${id}`, {
      scope: 'global',
      ...payload,
    })
  },

  archive(id) {
    return api.post(`/trainings/${id}/archive`)
  },

  restore(id) {
    return api.post(`/trainings/${id}/restore`)
  },

  // Localisation (US BO) — créer en 1 langue, générer les autres via le moteur,
  // puis éditer chaque langue.
  getTranslations(id) {
    return api.get(`/trainings/${id}/translations`)
  },

  localize(id, locales = null) {
    return api.post(`/trainings/${id}/localize`, locales ? { locales } : {})
  },

  saveTranslation(id, locale, payload) {
    return api.put(`/trainings/${id}/translations/${locale}`, payload)
  },
}
